import { AuthStatus } from '@interfaces/auth-status.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getAuthState = createFeatureSelector<AuthStatus>('auth');

export const getAuthStatus = createSelector(getAuthState, (state) => state);
